import React from "react";
import MUIDataTable from "mui-datatables";
  import axios from 'axios';
  import { connect } from "react-redux";
  import CustomToolbarSelect from "../toolbar/CustomToolbarSelect";
  import {addAvailableScripts} from "actions/index";
  import Loader from 'react-loader-spinner';

  import {ToastContainer, toast} from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

  const columns = [
    {
     name: "name",
     label: "Learner Name",
     options: {
      filter: true,
      sort: true,
     }
    },
    
    {
     name: "grade",
     label: "Grade",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "assessment",
     label: "Assessment",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "content_type",
      label: "Content Type",
      options: {
       filter: true,
       sort: true,
      }
     }
     ,
    {
      name: "assessed",
      label: "Assessed",
      options: {
       filter: true,
       sort: true,
      }
     },
    {
        name: "created_at",
        label: "Created At",
        options: {
         filter: true,
         sort: true,
        }
       }
   ];
   
   const options = {
     filterType: 'checkbox',
     customToolbarSelect: selectedRows => (
      <CustomToolbarSelect selectedRows={selectedRows} />
    )
   };
   const mapStateToProps = state => ({
    subject_selected: state.subject_selected,
    course_name: state.course_name,
    available_scripts: state.available_scripts
  });

  function mapDispatchToProps(dispatch) {
    return {
      addAvailableScripts: available_scripts => dispatch(addAvailableScripts(available_scripts))
    };
  }

class AssignedTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            subject_selected: props.subject_selected,
            available_scripts:[],
            course_name: '',
            table_data:[],
            tableDataLoading:true,
            marker_codes:[]
        };  
        // this.getAvailableScripts = this.getAvailableScripts.bind(this); 
        this.parseTableData = this.parseTableData.bind(this);   
        this.getAvailableScriptsAssigned = this.getAvailableScriptsAssigned.bind(this);   
      }

      componentDidMount(){
          // //console.log('checking scriptss',this.props);
          let user_role = localStorage.getItem('userRole');
          this.getMarkerCodes();    
          // if(user_role=='app-admin'){
          //   this.getAvailableScripts();
          // }else{
          //   this.getMarkerCodes();            
          // }          
      }

      getMarkerCodes(){
        let user_id = localStorage.getItem('user_id');
        let token = localStorage.getItem('access_token');
        let cur = this;
            axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-user-marker-codes/'+user_id, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                //console.log('marker codes', res.data);
                this.setState({marker_codes: res.data.marker_codes});
                this.getAvailableScriptsAssigned();
    
            }).catch(error => {
                //console.log('error', error);
                toast('An error occurred getting marer codes.'+error, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  type: toast.TYPE.ERROR
              });
            });
      }

      getAvailableScriptsAssigned(){
        let subject = this.state.subject_selected;
        console.log('subject_selected',subject);
        let data = {
          course_id:subject,
          marker_codes: this.state.marker_codes
        };
    
        const token = localStorage.getItem("access_token");
        axios({
          headers: {
            "content-type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          },
          method: "post",
          url: "https://admin.thinkdigitalacademy.org/api/marker-portal-get-available-scripts-assigned",
          data: data
      }).then(res => {
        console.log('assigned datar',res.data);
        this.setState({available_scripts:res.data.scripts,course_name:res.data.course.name});
        
        this.parseTableData();             
       //console.log('Check state dataassigned',this.state);
             
      }).catch(error => {
          this.setState({ tableDataLoading: false });
          toast('An error occurred getting grades.'+error, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: toast.TYPE.ERROR
        });
      });
      }

      // getAvailableScripts(){       
        
      //   axios.get('https://admin.thinkdigitalacademy.org/api/marker-portal-get-available-scripts/'+this.state.subject_selected).then(res=>{
      //         //console.log('scripts',res.data.course.name);   
      //         this.setState({available_scripts:res.data.scripts,course_name:res.data.course.name});             
      //         this.parseTableData();             
      //        //console.log('Check state data',this.state);
      //     }).catch(error =>{
      //         //console.log('error',error);
      //     }); 
      // }

      parseTableData(){
        //console.log('checkdata',this.state.available_scripts);
        let temp_actual_scripts = [];

        let temps = this.state.available_scripts.sort(function(a, b) {
          let fullnameA=a.student.name+" "+a.student.surname;
          let fullnameB=b.student.name+" "+b.student.surname;
          return fullnameA.localeCompare(fullnameB);
        });
        console.log('temps',temps)
          let data = temps.map((prop, key)=>{  
                
            if(prop.student && prop.grade && prop.assessment&&prop.assessed){
              temp_actual_scripts.push(prop);
              return [prop.student.name+' '+prop.student.surname,prop.grade.grade_name,prop.assessment.assessment_name,prop.content_type,prop.assessed,prop.created_at]
  
            }
          });
        //console.log("prop check",data);  
        var filtered = data.filter(function (el) {
          return el != null;
        });
        //console.log('filtered',filtered);
        this.props.addAvailableScripts(temp_actual_scripts);        
        this.setState({table_data:filtered,tableDataLoading:false,available_scripts:temp_actual_scripts});
      }

render(){
    return( 
      this.state.tableDataLoading ? (
      <div className="text-center py-5">
      <Loader
      type="Puff"
      color="#00BFFF"
      height={100}
      width={100}
   />
   <p className="text-muted mt-3 mb-0">Loading submissions…</p>
   </div>
   ):<> <ToastContainer position="top-right"
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   closeOnClick
   rtl={false}
   pauseOnFocusLoss
   draggable
   pauseOnHover/>
<ToastContainer/>
    <MUIDataTable
        title={this.state.course_name}
        data={this.state.table_data}
        columns={columns}
        options={options}
      />    </>
    );
  
} 

} export default connect(mapStateToProps,mapDispatchToProps)(AssignedTable);